"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Controller } from "@hotwired/stimulus";
import { renderDumbbell } from "../renderers/dumbbell";
import { renderUnit } from "../renderers/unit";
import { renderUpset } from "../renderers/upset";
import { renderBars } from "../renderers/bars";
const RENDERERS = { dumbbell: renderDumbbell, unit: renderUnit, upset: renderUpset, bars: renderBars };
export default class viz_controller_default extends Controller {
  connect() {
    const render = RENDERERS[this.typeValue];
    if (!render) return this.fail(`Unknown chart type: ${this.typeValue}`);
    if (!this.srcValue) return this.fail("Missing data-charts--viz-src-value");
    fetch(this.srcValue, { cache: "no-store" }).then((r) => {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    }).then((data) => render(this.element, data)).catch((e) => this.fail(`Could not load chart data (${e.message})`));
  }
  fail(msg) {
    this.element.innerHTML = `<p role="alert" class="db-src">${msg}</p>`;
    console.warn("[charts]", msg);
  }
}
__publicField(viz_controller_default, "values", { type: String, src: String });
